import React from "react";
import { useParams, useNavigate } from "react-router-dom";
import {
  BlogDetailsPageContainer,
  BlogTitle,
  BlogDate,
  BlogImage,
  BlogContent,
  ButtonContainer,
  Button,
} from "../Styles/Styledblog-details.js";
import b1 from '../Images/b1.webp'
import b2 from '../Images/b2.jpeg'
import b3 from '../Images/b3.webp'
import b4 from '../Images/b4.jpeg'
import b5 from '../Images/b5.jpeg'
import b6 from '../Images/b6.webp'
import b7 from '../Images/b7.jpeg'


const blogs = [
  {
    id: 1,
    date: "7/7/24",
    title: "Three Aspen Snowmass Real Estate Graphs Worth Understanding",
    content:
      "Aspen Snowmass real estate trends can be challenging to grasp without the right data. In this post, we analyze three essential graphs that reveal critical insights into market trends, property values, and buyer preferences. We delve into the rise in demand for luxury homes and the steady decline in average inventory. Additionally, we explore how these trends impact future investments. Understanding these graphs will empower you to make informed decisions. Learn about year-over-year price changes, seasonal buying trends, and market resilience. Gain an understanding of how pricing cycles affect both buyers and sellers. Discover how property types like single-family homes and condos behave differently in the market. Stay ahead in the competitive Aspen real estate market with these vital insights.",
    image: b1,
  },
  {
    id: 2,
    date: "2/18/24",
    title: "Who, What, Why, Where, When...How?",
    content:
      "In this blog, we tackle the timeless questions every aspiring buyer or seller must address. From defining your property goals to understanding local market conditions, we cover it all. Who are the key players in Aspen real estate? What factors influence pricing? Why is timing critical for successful transactions? Where are the hottest properties located, and how do you secure them? Learn actionable tips to simplify your real estate journey, avoid common pitfalls, and maximize value in every transaction. We also explore how technology plays a role in modern real estate, from virtual tours to AI-driven insights. Whether you're a first-time buyer or a seasoned investor, these foundational questions will guide your decisions.",
    image: b2,
  },
  {
    id: 3,
    date: "2/15/24",
    title: "Getting Paid Now and in the Future (Part 5 of 5): Referrals",
    content:
      "Referrals are the backbone of a thriving real estate business. In this final part of our series, we discuss how to leverage referrals to sustain long-term success. From building trust with clients to maintaining a professional network, we explore effective strategies for generating consistent leads. Learn why referrals often yield higher closing rates and foster client loyalty. Understand how to implement automated systems for tracking and rewarding referral sources. Master the art of asking for referrals without sounding pushy. We also share tips on building mutually beneficial relationships with other agents and industry professionals. By the end of this post, you’ll have actionable steps to create a referral system that keeps your pipeline full.",
    image: b3,
  },
  {
    id: 4,
    date: "6/12/24",
    title: "Top 10 Tips for Buying Your Dream Mountain Home",
    content:
      "Buying a mountain home is a dream for many, but it comes with unique challenges. This post highlights 10 essential tips to make the process smoother. From researching local zoning laws to understanding weather-related concerns, we’ve got you covered. We discuss how to evaluate potential properties for accessibility, especially during winter months. Learn the importance of working with a local agent familiar with mountain real estate. Discover financing options tailored for vacation or second homes. Find out how to assess the sustainability and environmental impact of your new property. Whether you’re looking for a cozy cabin or a luxury estate, these tips will help you secure the perfect mountain retreat.",
    image: b4,
  },
  {
    id: 5,
    date: "8/5/24",
    title: "What Makes a Home Truly Energy Efficient?",
    content:
      "Energy efficiency is a growing priority for homeowners, but what does it really mean? In this blog, we explore the key features that define an energy-efficient home. Learn about the latest advancements in insulation, windows, and HVAC systems that lower utility bills and reduce carbon footprints. We discuss the role of smart home technology in monitoring energy use. Explore how renewable energy sources, such as solar panels, can significantly impact your home’s efficiency. Understand the importance of energy certifications like LEED and Energy Star when buying or selling properties. Discover practical tips to improve efficiency without major renovations. By making smart choices, you can create a comfortable, sustainable living environment.",
    image: b5,
  },
  {
    id: 6,
    date: "3/10/24",
    title: "The Hidden Costs of Selling a Home",
    content:
      "Selling a home is about more than just listing it on the market. This post dives into the hidden costs sellers often overlook. From staging and professional photography to legal fees and closing costs, we break down all the expenses involved. Learn how to budget effectively and minimize unnecessary costs. We also discuss the importance of pre-inspections and minor repairs to attract buyers and avoid negotiations later. Explore how marketing strategies like online ads or open houses can impact your selling expenses. With proper planning, you can maximize your profit while keeping costs under control.",
    image: b6,
  },
  {
    id: 7,
    date: "5/1/24",
    title: "How to Negotiate Like a Pro in Real Estate Deals",
    content:
      "Negotiation is a critical skill in real estate transactions, and mastering it can make all the difference. In this blog, we share practical tips to help you negotiate effectively. Learn the art of understanding the other party’s motivations and using them to your advantage. We discuss when to compromise and when to stand firm. Discover how data, such as recent sales and market trends, can strengthen your position. We also explore common mistakes to avoid during negotiations. Whether you're buying your dream home or selling an investment property, these tips will help you secure the best deal possible.",
    image: b7,
  },
];
const BlogDetailsPage = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const blog = blogs.find((blog) => blog.id === parseInt(id));

  if (!blog) {
    return <p className="text-center text-red-500 text-lg">Blog not found.</p>;
  }

  const currentIndex = blogs.findIndex((b) => b.id === parseInt(id));
  const prevBlog = blogs[currentIndex - 1];
  const nextBlog = blogs[currentIndex + 1];

  const handlePrevClick = () => {
    if (!prevBlog) return;
    navigate(`/blog/${prevBlog.id}`);
  };

  const handleNextClick = () => {
    if (!nextBlog) return;
    navigate(`/blog/${nextBlog.id}`);
  };

  return (
    <BlogDetailsPageContainer>
      <BlogTitle>{blog.title}</BlogTitle>
      <BlogDate>{blog.date}</BlogDate>
      <BlogImage src={blog.image} alt={blog.title} />
      <BlogContent>{blog.content}</BlogContent>
      <ButtonContainer>
        <Button onClick={handlePrevClick} disabled={!prevBlog}>
          Previous Blog
        </Button>
        <Button onClick={handleNextClick} disabled={!nextBlog}>
          Next Blog
        </Button>
      </ButtonContainer>
    </BlogDetailsPageContainer>
  );
};

export default BlogDetailsPage;
